import { render, staticRenderFns } from "./MultiImageField.vue?vue&type=template&id=01622a84&scoped=true"
import script from "./MultiImageField.vue?vue&type=script&lang=js"
export * from "./MultiImageField.vue?vue&type=script&lang=js"
import style0 from "./MultiImageField.vue?vue&type=style&index=0&id=01622a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01622a84",
  null
  
)

export default component.exports